"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyQuotationSummary = void 0;
var QuotationStatus_1 = require("./QuotationStatus");
var QuotationProfile_1 = require("./QuotationProfile");
function makeEmptyQuotationSummary() {
    return {
        id: -1,
        urlSalt: '',
        status: QuotationStatus_1.makeEmptyQuotationStatus(),
        customerName: '',
        carBrand: '',
        carModel: '',
        carYear: '',
        quotationDate: '',
        anualPayment: 0,
        insuranceValue: 0,
        description: '',
        productType: '',
        quotationSequence: 0,
        username: '',
        userRole: '',
        origin: '',
        expirationDate: '',
        profile: QuotationProfile_1.makeEmptyQuotationProfile(),
        license: '',
    };
}
exports.makeEmptyQuotationSummary = makeEmptyQuotationSummary;
//# sourceMappingURL=QuotationSummaryResponse.js.map